export const Roles = {
	ROOT: 'root',
	ADMIN: 'admin',
	WAITER: 'waiter',
	SUPPLIER: 'supplier',  
}